import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import NavBar from "../components/Navigation/Navbar";

const isAuthenticated = () => {
  var token = localStorage.getItem("token");
  if (token == null) {
    return false;
  } else {
    return true;
  }
};

export const ProtectedRoute = () => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex-order">
      <NavBar />
      <Outlet className="example" />
    </div>
  );
};
